import React, { type FC, type ReactNode, useReducer } from "react";
import userActionsMetadataReducer from "./reducer";
import type { UserActionsMetadataState } from "./types";

export const DEFAULT_USER_ACTIONS_METADATA: UserActionsMetadataState = {
  metadata: {},
};

export const UserActionsMetadataContext = React.createContext<{
  state: UserActionsMetadataState;
  dispatch: React.Dispatch<any>;
}>({ state: DEFAULT_USER_ACTIONS_METADATA, dispatch: () => {} });

export const UserActionsMetadataContextProvider: FC<{
  children?: ReactNode;
}> = ({ children }) => {
  const [state, dispatch] = useReducer(
    userActionsMetadataReducer,
    DEFAULT_USER_ACTIONS_METADATA
  );

  return (
    <UserActionsMetadataContext.Provider value={{ state, dispatch }}>
      {children}
    </UserActionsMetadataContext.Provider>
  );
};
